
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1584_7718)"}},[_c('path',{attrs:{"d":"M16.266 19.778h5.178a.555.555 0 00.556-.556V4.778a.556.556 0 00-.556-.556h-5.178v15.556zM20.334 17h-3.89v-1.666h3.89V17zm0-2.778h-3.89v-1.666h3.89v1.666zm0-2.778h-3.89V9.778h3.89v1.666zm0-2.777h-3.89V7h3.89v1.666z","fill":"#4CAF50"}}),_c('path',{attrs:{"d":"M2 4.222v15.556L16.703 22V2L2 4.222zm3.905 10.393c.316.02.668-.07.874-.195l.159 1.38c-.193.141-.627.267-1.19.208-1.605-.17-2.431-1.756-2.431-3.742 0-2.378 1.13-3.838 2.534-4.005.544-.065.957.069 1.144.208L6.78 9.88a1.434 1.434 0 00-.882-.216c-.833.066-1.48.898-1.48 2.502-.002 1.445.55 2.39 1.486 2.45zm2.858 1.712c-.53-.056-1.054-.348-1.315-.618l.213-1.461c.283.264.717.54 1.164.57.483.029.738-.312.738-.856 0-.52-.221-.82-.779-1.183-.771-.47-1.274-1.195-1.274-2.341 0-1.346.66-2.455 1.755-2.586.524-.063.91.092 1.185.289l-.234 1.572c-.186-.15-.517-.362-.971-.327-.455.035-.675.416-.675.836 0 .518.261.737.86 1.121.82.531 1.206 1.314 1.206 2.522 0 1.438-.598 2.596-1.873 2.462zm4.904.38l-1.226-.126-1.487-8.79 1.15-.134.566 3.746a63.63 63.63 0 01.413 3.245h.02c.117-1.091.262-2.175.42-3.226l.593-4 1.116-.13-1.565 9.415z","fill":"#2E7D32"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1584_7718"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 2)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    